import Component from '@glimmer/component';

export default class MwIconsWithText extends Component {}
